import React from "react";
import { createRoot } from "react-dom/client";
import { LiciVista } from "./LiciVista";
import '../../Globals/Styles/styles.css';
import './styles.css';

const container = document.getElementById("id-lici-vista");
if (container) {
    const root = createRoot(container, {});
    root.render(
        <React.StrictMode>
            <LiciVista/>
        </React.StrictMode>
    );
}
else {
    console.error("Error: El contenedor raíz para la aplicación React no fue encontrado.");
}